import Global from '@/mixins/Global'
import mods from '../../../.smsconfig.json'

export default {
    install(Vue, options) {

        const optionsDefaults = {}

        // Merge options argument into options defaults
        options = {
            ...optionsDefaults,
            ...options
        }
        Vue.prototype.$mods = mods;
        Vue.mixin(Global);

      
    }
}